import LookupEventTypesRequestModelBase from '../_generated/modelBases/lookup-event-types-request-model-base';

export default class LookupEventTypesRequestModel extends LookupEventTypesRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
